"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSearchResultPost = isSearchResultPost;
exports.isSearchResultTopic = isSearchResultTopic;
exports.isSearchResultArticle = isSearchResultArticle;
function isSearchResultPost(item) {
    return 'postId' in item;
}
function isSearchResultTopic(item) {
    return 'postsCount' in item && !('postId' in item);
}
function isSearchResultArticle(item) {
    return 'previewText' in item;
}
